import { useLocation, useNavigate } from "react-router-dom";

import Male from './../../assets/img/Man1.png'
import Female from './../../assets/img/Woman1.png'
import BackBtn from "../../compoment/icon/BackBtn";


const ChooseFriendAvatarScreen = () => {
    const navigate = useNavigate();
    const location = useLocation()

    const handleBack = () => {
        localStorage.removeItem('friendGender')
        navigate("/choose-avatar");
    };

    const handleChooseAvatar = (gender: string) => {
        localStorage.setItem('friendGender', gender)
        navigate('/magic')
    };


    return (
        <>
            <section className="colorSection portraitDevice">
                <div className="mainContainerSection">
                    <div>
                        <button className="backBTN" onClick={handleBack}>
                        <span className="me-2"><BackBtn /></span> Back
                        </button>
                    </div>
                    <div className="headingJoining mt-0">{`Choose your friend’s avatar`}</div>
                    <div className="lanternContainer" style={{ columnGap: 32 }}>
                        <div className="singleLanternJoining">
                            <div style={{ width: 250 }}> <img className="w-75 mx-auto" style={{ borderRadius: 12 }} src={Male} alt="" />  </div>
                            <button className="lanternBtn" onClick={() => handleChooseAvatar('male')}>Male</button>
                        </div>
                        <div className="singleLanternJoining">
                            <div style={{ width: 250 }}> <img className="w-75 mx-auto" style={{ borderRadius: 12 }} src={Female} alt="" /> </div>
                            <button className="lanternBtn" onClick={() => handleChooseAvatar('female')}>Female</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ChooseFriendAvatarScreen;
